<template>
    <v-list two-line>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    Id
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{service.id}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    Code
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{service.code}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    Title
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{service.title}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    Creation datetime
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{creationDate}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    Base price
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{service.price | currency}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import {formatPeriodExecution} from '../../../helpers/timeformats'
    import moment from 'moment'
    import _ from 'lodash'

    export default {
        name: "OverviewService",
        props: {
            service: Object
        },
        computed: {
            ...mapGetters({
                serviceById: 'services/serviceById',
            }),
            ...mapState('services', {

            }),
            creationDate () {
                return moment(this.service.createdAt).format('YYYY-MM-DD HH:mm:ss')
            }
        }
    }
</script>

<style scoped>

</style>